import { useContext, useMemo } from "react";
import { SplashContext } from "../App";

function getStoredSplashData() {
  try {
    return JSON.parse(localStorage.getItem("SplashData") || "null");
  } catch {
    return null;
  }
}

/**
 * Returns the advertisements already loaded by the app splash request.
 * Individual page APIs can still provide their page data without causing an
 * advertisement refresh whenever those queries run.
 */
export function useSplashAds() {
  const splashContext = useContext(SplashContext);
  const splashResult = splashContext?.splashResult;

  const splashData = useMemo(
    () => splashResult || getStoredSplashData(),
    [splashResult]
  );

  return {
    ads: splashData?.ads || {},
    isReady: Boolean(splashData?.ads),
  };
}
